export default __webpack_public_path__ + "static/media/mountainlandscape.cee187bc.jpg";